import { call, put, select, takeLatest } from 'redux-saga/effects'
import { SignaturesConstants } from '../store/signatures.constants'
import { getServiceIdSelector } from '../../user/selectors'
import { ISignaturesState } from '../store/signatures.types'
import { getPcrIdSelector } from '../../home/selectors'
import { getSignaturesSelector } from '../selectors/getSignatures.selector'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* saveSignaturesPcr() {
  const signatures: ISignaturesState = yield select(getSignaturesSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const pcrDocUpdated = { ...pcrDoc, signatures }
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveSignatures() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* saveSignaturesPcrSaga() {
  yield takeLatest([SignaturesConstants.SAVE_SIGNATURES_PCR], performWithMutexHOG, saveSignaturesPcr)
}
